import React from 'react';
import UserProfileMenu from './user-profile-menu';
import NotificationButton from './NotificationButton';
import TasksButton from './TasksButton';
import StorageButton from './StorageButton';
import { useAuth } from '@/contexts/auth';
import NavItem from '../../layout/NavItem';
import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import HomeButton from './HomeButton';
import LibrariesButton from './LibrariesButton';
import { useIsMobile } from '@/hooks/layout/use-mobile';
import ProjectsDropdown from './ProjectsDropdown';

const DashboardTopNav = () => {
  const { user } = useAuth();
  const location = useLocation();
  const { isMobile } = useIsMobile();

  return (
    <div className="sticky top-0 z-100 w-full">
      <div className="relative">
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-brandBlue/10 via-brandPurple/5 to-brandBlue/10 dark:from-brandBlue/20 dark:via-brandPurple/10 dark:to-brandBlue/20" />
        
        {/* Glass effect */}
        <div className={cn("relative backdrop-blur-xl bg-white/90 border-b", "dark:bg-slate-900/80 dark:border-slate-700/40", "shadow-sm")}>
          {/* Top border gradient */}
          <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-accent via-brand-gradient-to to-brand-gradient-from" />
          
          <div className="flex h-16 items-center px-2">
            {/* Left side - Home, Libraries (desktop only) buttons */}
            <div className="flex items-center space-x-1.5">
              <HomeButton size={20} />
              {/* 
                🚫 PUBLIC LIBRARIES BUTTON - TEMPORARILY HIDDEN
                Uncomment the line below to restore the Public Libraries dropdown button
                {!isMobile && <LibrariesButton size={20} />}
              */}
            </div>
            
            {/* Center - Projects dropdown */}
            <div className="flex-1 flex justify-center">
              <ProjectsDropdown 
                isActive={location.pathname.startsWith('/project-manager')}
              />
            </div>
            
            {/* Right side - Tasks, Notifications, Storage and Account dropdown */}
            <div className="flex items-center space-x-2">
              {/* Hide these buttons on mobile - they'll be in the user menu */}
              {!isMobile && (
                <>
                  <TasksButton />
                  <NotificationButton />
                  <StorageButton size={18} />
                </>
              )}
              <UserProfileMenu user={user} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardTopNav;
